import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { getBookingsBanner, getAgentsBanner } from 'Store/Banners/selectors';
import BannerBookingsAndAgents from 'Components/BannerBookingsAndAgents/BannerBookingsAndAgents';

interface IPropsInternal {
  agentsContent: Julius.Content.Banner;
  bookingsContent: Julius.Content.Banner;
}

class BannerBookingsAndAgentsContainer extends React.PureComponent<IPropsInternal> {
  render() {
    return (
      <BannerBookingsAndAgents
        agentsContent={ this.props.agentsContent }
        bookingsContent={ this.props.bookingsContent }
        localPathAgents='/ombud'
        localPathBookings='/gruppbokning'
      />
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    bookingsContent: getBookingsBanner(state),
    agentsContent: getAgentsBanner(state),
  };
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, null),
)(BannerBookingsAndAgentsContainer);


// WEBPACK FOOTER //
// ./src/components/BannerBookingsAndAgents/BannerBookingsAndAgentsContainer.tsx